module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-form"
  }, [_c('joi-form', {
    attrs: {
      "data": _vm.data,
      "schema": _vm.validationSchema,
      "error": _vm.formError
    },
    on: {
      "formdataready": _vm.save
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-4 columns small-centered"
  }, [_c('span', {
    attrs: {
      "data-form-error-callout": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          Megnevezés:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.title),
      expression: "data.title"
    }],
    attrs: {
      "type": "text",
      "name": "title"
    },
    domProps: {
      "value": (_vm.data.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', {
    attrs: {
      "error-path": "channels"
    }
  }, [_vm._v("\n          Oldalak:\n          "), _c('channel-selector', {
    model: {
      value: (_vm.data.channels),
      callback: function($$v) {
        _vm.$set(_vm.data, "channels", $$v)
      },
      expression: "data.channels"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('label', [_vm._v("\n          Posztok forrása:\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.postSource),
      expression: "data.postSource"
    }],
    attrs: {
      "id": "postSource-pageFeedPosts",
      "type": "radio",
      "value": "pageFeedPosts"
    },
    domProps: {
      "checked": _vm._q(_vm.data.postSource, "pageFeedPosts")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "postSource", "pageFeedPosts")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "postSource-pageFeedPosts"
    }
  }, [_vm._v("Hírfolyamposztok")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.postSource),
      expression: "data.postSource"
    }],
    attrs: {
      "id": "postSource-pagePublishedPosts",
      "type": "radio",
      "value": "pagePublishedPosts"
    },
    domProps: {
      "checked": _vm._q(_vm.data.postSource, "pagePublishedPosts")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "postSource", "pagePublishedPosts")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "postSource-pagePublishedPosts"
    }
  }, [_vm._v("Publikált posztok")]), _vm._v(" "), _c('span', {
    attrs: {
      "error-path": "postSource"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          Vizsgált időszak:\n          "), _c('date-picker', {
    attrs: {
      "mode": "range",
      "error-path": "interval"
    },
    model: {
      value: (_vm.data.interval),
      callback: function($$v) {
        _vm.$set(_vm.data, "interval", $$v)
      },
      expression: "data.interval"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "error-path": "interval.min"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "error-path": "interval.max"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded bottom"
  }, [_c('div', {
    staticClass: "small-4 columns"
  }, [_c('button', {
    staticClass: "button primary trans-uppercase",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), (_vm.data.id) ? _c('button', {
    staticClass: "button alert trans-uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Törlés")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button secondary trans-uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Vissza")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aa398efc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/analytics/Edit.vue
// module id = 489
// module chunks = 2